import { SandboxSession } from './types';

export const ACTIVE_WINDOW_APPLICATIONS = [
  'Counter-Strike',
  'Dota 2',
  'Fortnite',
  'Minecraft',
  'Chrome',
] as const;

export const activeWindowForHost = (
  hostId: number,
  sessions: SandboxSession[]
): string => {
  const active = sessions.find(
    (session) => session.host_id === hostId && session.status === 'ACTIVE'
  );
  if (!active) return 'SmartShell';
  return ACTIVE_WINDOW_APPLICATIONS[
    (hostId - 1) % ACTIVE_WINDOW_APPLICATIONS.length
  ];
};
